'use strict';

/**
 * Single source of truth for collab-project JSON/binary endpoint URLs.
 * Endpoints live under dynamic/admin/api/projects/ — see dynamic/CLAUDE.md.
 */
export const PROJECT_API = {
  image:         '/dynamic/admin/api/projects/image.php',
  imageUpload:   '/dynamic/admin/api/projects/image_upload.php',
  imageList:     '/dynamic/admin/api/projects/image_list.php',
  imageDelete:   '/dynamic/admin/api/projects/image_delete.php',
  updateSave:    '/dynamic/admin/api/projects/update_save.php',
  updateComment: '/dynamic/admin/api/projects/update_comment.php',
};

export const imageUrl = id => `${PROJECT_API.image}?id=${encodeURIComponent(id)}`;

// Set on fetch() calls so AppContext::failsAsJson() recognises the request as
// JSON-answering even though it authenticates by session cookie, not a Bearer
// token — see dynamic/lib/AppContext.php useJsonErrors()/failsAsJson().
export const JSON_HEADERS = { Accept: 'application/json' };
